export default "__VITE_ASSET__BEQ73PO2__"